import dashboard from "./en/dashboard.json";
import translation from "./en/translation.json";
import transport from "./en/transport.json";
import shipment from "./en/shipment.json";
import login from "./en/login.json";
import menu from "./en/menu.json";
import admin from "./en/admin.json";
import finance from "./en/finance.json";
import reports from "./en/reports.json";
import tools from "./en/tools.json";
import documents from "./en/documents.json";
import intransit from "./en/intransit.json";

let items = {
  ...dashboard,
  ...translation,
  ...login,
  ...menu,
  ...admin,
  ...shipment,
  ...transport,
  ...finance,
  ...reports,
  ...tools,
  ...documents,
  ...intransit,
};

export default items;
